
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/golf-club-storage",
      function () {
        return require("private-next-pages/golf-club-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/golf-club-storage"])
      });
    }
  